import paydayAssets from '../scenes/SalesPages/PayDay/payDayImages';

export const MOCK_ALL_OFFERS = {
  status: true,
  data: [
    {
      offer_image: 'https://cdn.twidpay.com/co/offer_banner/twid-default.png',
      offer_type: 'CASHBACK',
      offer_tag: 'cashback',
      offer_title: 'Get ₹320 Cashback',
      offer_subtitle: 'Flat 4% off upto 500 on mov of 7999',
      brand_id: 67521,
      merchant_rank: '45',
      offer_value: '320',
      is_single_merchant: true,
      brand_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/easemytripsquare.png',
      applicable_brand_logos: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      target_coupon_details: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      brand_name: 'EaseMytrip',
      code: 'EMTJAN5',
      category_id: 1,
      type: 'online',
      voucher_id: null,
      voucher_campaign_details_id: 4340,
      reward_details_id: null,
      expiry_date: '2025-01-31 23:59:59',
      expiry_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/expiry.png',
      expiry_text: 'Valid till 31 JAN 25',
      expiry_text_color: '#F7F8FC',
      tag_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/cashback_icon.svg',
      tag_text: 'Cashback',
      tag_color: 'E5A500',
      is_external_voucher: 0,
      is_growth_campaign_present: false,
      is_growth_campaign_voucher_present: false,
      is_claimable: 0,
      applicable_payment_methods: null,
      voucher_additional_condition: {
        min_total_issuers: null,
        max_total_issuers: null,
        min_total_redeemable_amount: null,
        max_total_redeemable_amount: null,
        reward_coins: false,
        reward_coins_issuer: null,
        coupon_target_brand_id: null,
      },
      additional_info: {
        include_brand_id: null,
        exclude_brand_id: null,
      },
      distribution_channel: null,
      offer_filter_type: 'other_cashback',
    },
    {
      offer_image: 'https://cdn.twidpay.com/co/offer_banner/twid-default.png',
      offer_type: 'CASHBACK',
      offer_tag: 'cashback',
      offer_title: 'Get ₹60 Cashback',
      offer_subtitle: '5% upto Rs.100 Cashback, MOV 699',
      brand_id: 75507,
      merchant_rank: '74',
      offer_value: '60',
      is_single_merchant: true,
      brand_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/igpsquare.png',
      applicable_brand_logos: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      target_coupon_details: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      brand_name: 'IGP',
      code: 'IGPJAN0',
      category_id: 37,
      type: 'online',
      voucher_id: null,
      voucher_campaign_details_id: 4283,
      reward_details_id: null,
      expiry_date: '2025-01-31 23:59:59',
      expiry_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/expiry.png',
      expiry_text: 'Valid till 31 JAN 25',
      expiry_text_color: '#F7F8FC',
      tag_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/cashback_icon.svg',
      tag_text: 'Cashback',
      tag_color: 'E5A500',
      is_external_voucher: 0,
      is_growth_campaign_present: false,
      is_growth_campaign_voucher_present: false,
      is_claimable: 0,
      applicable_payment_methods: null,
      voucher_additional_condition: {
        min_total_issuers: null,
        max_total_issuers: null,
        min_total_redeemable_amount: null,
        max_total_redeemable_amount: null,
        reward_coins: false,
        reward_coins_issuer: null,
        coupon_target_brand_id: null,
      },
      additional_info: {
        include_brand_id: null,
        exclude_brand_id: null,
      },
      distribution_channel: null,
      offer_filter_type: 'other_cashback',
    },
    {
      offer_image:
        'https://cdn.twidpay.com/cohttps://static.twidpay.com/me/brand_images/timesprime.png',
      offer_type: 'CASHBACK',
      offer_tag: 'cashback',
      offer_title: 'Get ₹50 Cashback',
      offer_subtitle:
        'Get flat Rs.50 cashback on minimum order value of Rs.849',
      brand_id: 75957,
      merchant_rank: '72',
      offer_value: '50',
      is_single_merchant: true,
      brand_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/timesprimesquare.png',
      applicable_brand_logos: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      target_coupon_details: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      brand_name: 'TimesPrime',
      code: 'PRIMEJAN',
      category_id: 41,
      type: 'online',
      voucher_id: null,
      voucher_campaign_details_id: 4351,
      reward_details_id: null,
      expiry_date: '2025-01-31 23:59:59',
      expiry_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/expiry.png',
      expiry_text: 'Valid till 31 JAN 25',
      expiry_text_color: '#F7F8FC',
      tag_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/cashback_icon.svg',
      tag_text: 'Cashback',
      tag_color: 'E5A500',
      is_external_voucher: 0,
      is_growth_campaign_present: false,
      is_growth_campaign_voucher_present: false,
      is_claimable: 0,
      applicable_payment_methods: null,
      voucher_additional_condition: {
        min_total_issuers: null,
        max_total_issuers: null,
        min_total_redeemable_amount: null,
        max_total_redeemable_amount: 15,
        reward_coins: false,
        reward_coins_issuer: null,
        coupon_target_brand_id: null,
      },
      additional_info: {
        include_brand_id: null,
        exclude_brand_id: null,
      },
      distribution_channel: null,
      offer_filter_type: 'other_cashback',
    },
    {
      offer_image: 'https://cdn.twidpay.com/co/offer_banner/twid-default.png',
      offer_type: 'CASHBACK',
      offer_tag: 'cashback',
      offer_title: 'Get ₹10 Cashback',
      offer_subtitle: 'Rs.10 Cashback',
      brand_id: 67521,
      merchant_rank: '45',
      offer_value: '10',
      is_single_merchant: true,
      brand_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/easemytripsquare.png',
      applicable_brand_logos: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      target_coupon_details: {
        logos: [],
        extra_count: null,
        brand_ids: [],
        brand_names: [],
        category_ids: [],
      },
      brand_name: 'EaseMytrip',
      code: 'EMTJAN0',
      category_id: 1,
      type: 'online',
      voucher_id: null,
      voucher_campaign_details_id: 4339,
      reward_details_id: null,
      expiry_date: '2025-01-31 23:59:59',
      expiry_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/expiry.png',
      expiry_text: 'Valid till 31 JAN 25',
      expiry_text_color: '#F7F8FC',
      tag_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/cashback_icon.svg',
      tag_text: 'Cashback',
      tag_color: 'E5A500',
      is_external_voucher: 0,
      is_growth_campaign_present: false,
      is_growth_campaign_voucher_present: false,
      is_claimable: 0,
      applicable_payment_methods: null,
      voucher_additional_condition: {
        min_total_issuers: null,
        max_total_issuers: null,
        min_total_redeemable_amount: null,
        max_total_redeemable_amount: null,
        reward_coins: false,
        reward_coins_issuer: null,
        coupon_target_brand_id: null,
      },
      additional_info: {
        include_brand_id: null,
        exclude_brand_id: null,
      },
      distribution_channel: null,
      offer_filter_type: 'other_cashback',
    },
    {
      offer_image: 'https://cdn.twidpay.com/co/offer_banner/twid-default.png',
      offer_type: 'EXCLUSIVE',
      offer_tag: 'exclusive_cashback',
      offer_title: 'Get Upto Rs 3000/- off on EaseMyTrip.',
      offer_subtitle: 'Get Upto Rs 3000/- off on EaseMyTrip.',
      brand_id: 1,
      merchant_rank: null,
      offer_value: 'Others',
      is_single_merchant: false,
      brand_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/easemytripsquare.png',
      applicable_brand_logos: {
        logos: [
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/jiomartsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/bookmyshowsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
        ],
        extra_count: null,
        brand_ids: [
          '75492',
          '323',
          '75548',
          '75549',
          '75550',
          '75551',
          '74863',
          '75596',
          '75554',
          '325',
        ],
        brand_names: [
          'Netmeds',
          'Jio Fiber Payment',
          'Jio Fiber Registration',
          'EatSure',
          'Jio prepaid',
          'Jio Postpaid',
          'Jiomart',
          'BookMyShow',
        ],
        category_ids: [46, 39, 17, 2, 16, 14],
      },
      target_coupon_details: {
        logos: [
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/easemytripsquare.png',
        ],
        extra_count: null,
        brand_ids: ['67521'],
        brand_names: ['EaseMytrip'],
        category_ids: [1],
      },
      brand_name: 'EaseMytrip',
      code: 'EMTTWID',
      category_id: 11,
      type: 'online',
      voucher_id: null,
      voucher_campaign_details_id: 3724,
      reward_details_id: null,
      expiry_date: '2025-01-31 23:59:59',
      expiry_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/expiry.png',
      expiry_text: 'Valid till 31 JAN 25',
      expiry_text_color: '#F7F8FC',
      tag_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/exclusive.png',
      tag_text: 'Exclusive',
      tag_color: 'FF7F53',
      is_external_voucher: 1,
      is_growth_campaign_present: false,
      is_growth_campaign_voucher_present: false,
      is_claimable: 1,
      applicable_payment_methods: null,
      voucher_additional_condition: {
        min_total_issuers: null,
        max_total_issuers: null,
        min_total_redeemable_amount: null,
        max_total_redeemable_amount: null,
        reward_coins: false,
        reward_coins_issuer: null,
        coupon_target_brand_id: '67521',
      },
      additional_info: {
        include_brand_id:
          '75492,323,75548,75549,75550,75551,74863,75596,75554,325',
        exclude_brand_id: null,
      },
      distribution_channel: null,
      offer_filter_type: 'exclusive',
    },
    {
      offer_image: 'https://cdn.twidpay.com/co/offer_banner/twid-default.png',
      offer_type: 'EXCLUSIVE',
      offer_tag: 'exclusive_cashback',
      offer_title: 'Flat Rs 120 off on orders above Rs 299',
      offer_subtitle: 'Flat Rs 120 off on orders above Rs 299',
      brand_id: 1,
      merchant_rank: null,
      offer_value: 'Others',
      is_single_merchant: false,
      brand_logo:
        'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
      applicable_brand_logos: {
        logos: [
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/milkbasketsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/abhibussquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/licioussquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/wakefitsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/jiomartsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/deeprootedsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/bookmyshowsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/igpsquare.png',
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
        ],
        extra_count: null,
        brand_ids: [
          '75492',
          '323',
          '75548',
          '75549',
          '75550',
          '75551',
          '74863',
          '75596',
          '75554',
          '325',
          '75560',
          '75517',
          '68644',
          '70629',
          '69079',
          '67501',
          '75563',
          '75507',
        ],
        brand_names: [
          'Netmeds',
          'Jio Fiber Payment',
          'Milkbasket',
          'Jio Fiber Registration',
          'EatSure',
          'AbhiBus',
          'Jio prepaid',
          'Jio Postpaid',
          'Licious',
          'Wakefit',
          'Jiomart',
          'DeepRooted',
          'BookMyShow',
          'IGP',
        ],
        category_ids: [46, 39, 2, 17, 1, 47, 16, 14, 37],
      },
      target_coupon_details: {
        logos: [
          'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
        ],
        extra_count: null,
        brand_ids: ['74863'],
        brand_names: ['EatSure'],
        category_ids: [17],
      },
      brand_name: 'EatSure',
      code: 'TWIDES120',
      category_id: 11,
      type: 'online',
      voucher_id: null,
      voucher_campaign_details_id: 3740,
      reward_details_id: null,
      expiry_date: '2025-12-31 23:59:59',
      expiry_logo: null,
      expiry_text: null,
      expiry_text_color: null,
      tag_url:
        'https://cdn.twidpay.com/co/mobile_app_images/icons/exclusive.png',
      tag_text: 'Exclusive',
      tag_color: 'FF7F53',
      is_external_voucher: 1,
      is_growth_campaign_present: false,
      is_growth_campaign_voucher_present: false,
      is_claimable: 1,
      applicable_payment_methods: null,
      voucher_additional_condition: {
        min_total_issuers: null,
        max_total_issuers: null,
        min_total_redeemable_amount: null,
        max_total_redeemable_amount: null,
        reward_coins: false,
        reward_coins_issuer: null,
        coupon_target_brand_id: '74863',
      },
      additional_info: {
        include_brand_id:
          '75492,323,75548,75549,75550,75551,74863,75596,75554,325,75560,75517,68644,70629,69079,67501,75563,75507',
        exclude_brand_id: null,
      },
      distribution_channel: null,
      offer_filter_type: 'exclusive',
    },
  ],
  error_code: null,
  message: null,
  filters: {
    category: [
      {
        id: 37,
        name: 'Lifestyle',
        redeem_type: 'online',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_b4ff6_1734341014.png',
      },
      {
        id: 39,
        name: 'Mobile/Internet Recharge',
        redeem_type: 'online',
        logo: 'https://cdn.twidpay.com/co/category_images/Mobile_Internet_Recharge.jpg',
      },
      {
        id: 1,
        name: 'Travel',
        redeem_type: 'online',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_b34c2_1734341238.png',
      },
      {
        id: 2,
        name: 'Groceries',
        redeem_type: 'online',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_5e146_1734341264.png',
      },
      {
        id: 16,
        name: 'E-Pharmacy',
        redeem_type: 'offline',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_10eba_1734340844.png',
      },
      {
        id: 46,
        name: 'Healthcare',
        redeem_type: 'offline',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_c54f2_1734341196.png',
      },
      {
        id: 17,
        name: 'Food',
        redeem_type: 'offline',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_569ce_1734340984.png',
      },
      {
        id: 41,
        name: 'Others',
        redeem_type: 'online',
        logo: 'https://cdn.twidpay.com/co/category_images/category_image_0db31_1734341042.png',
      },
      {
        id: 47,
        name: 'Essentials',
        redeem_type: 'offline',
        logo: 'https://cdn.twidpay.com/co/category_images/Essentials.jpg',
      },
    ],
    brand: {
      preferred_brands: [
        {
          merchant_id: 75549,
          merchant_name: 'Jio prepaid',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          primary_category_id: 39,
          merchant_type: null,
          merchant_rank: '2',
        },
        {
          merchant_id: 75492,
          merchant_name: 'Jiomart',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/jiomartsquare.png',
          primary_category_id: 2,
          merchant_type: null,
          merchant_rank: '5',
        },
        {
          merchant_id: 323,
          merchant_name: 'BookMyShow',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/bookmyshowsquare.png',
          primary_category_id: 14,
          merchant_type: null,
          merchant_rank: '7',
        },
        {
          merchant_id: 75554,
          merchant_name: 'Netmeds',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          primary_category_id: 46,
          merchant_type: null,
          merchant_rank: '10',
        },
        {
          merchant_id: 75550,
          merchant_name: 'Jio Fiber Payment',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          primary_category_id: 39,
          merchant_type: null,
          merchant_rank: '11',
        },
      ],
      all_other_brands: [
        {
          merchant_id: 75517,
          merchant_name: 'Milkbasket',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/milkbasketsquare.png',
          primary_category_id: 2,
          merchant_type: null,
          merchant_rank: '12',
        },
        {
          merchant_id: 75548,
          merchant_name: 'Jio Fiber Registration',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          primary_category_id: 39,
          merchant_type: null,
          merchant_rank: '14',
        },
        {
          merchant_id: 74863,
          merchant_name: 'EatSure',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
          primary_category_id: 17,
          merchant_type: null,
          merchant_rank: '15',
        },
        {
          merchant_id: 68644,
          merchant_name: 'AbhiBus',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/abhibussquare.png',
          primary_category_id: 1,
          merchant_type: null,
          merchant_rank: '18',
        },
        {
          merchant_id: 75551,
          merchant_name: 'Jio Postpaid',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/myjiosquare.png',
          primary_category_id: 39,
          merchant_type: null,
          merchant_rank: '22',
        },
        {
          merchant_id: 75560,
          merchant_name: 'Licious',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/licioussquare.png',
          primary_category_id: 17,
          merchant_type: null,
          merchant_rank: '26',
        },
        {
          merchant_id: 70629,
          merchant_name: 'Wakefit',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/wakefitsquare.png',
          primary_category_id: 47,
          merchant_type: null,
          merchant_rank: '46',
        },
        {
          merchant_id: 325,
          merchant_name: 'Netmeds',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          primary_category_id: 16,
          merchant_type: null,
          merchant_rank: '51',
        },
        {
          merchant_id: 75563,
          merchant_name: 'DeepRooted',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/deeprootedsquare.png',
          primary_category_id: 17,
          merchant_type: null,
          merchant_rank: '54',
        },
        {
          merchant_id: 75507,
          merchant_name: 'IGP',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/igpsquare.png',
          primary_category_id: 37,
          merchant_type: null,
          merchant_rank: '74',
        },
        {
          merchant_id: 75596,
          merchant_name: 'Netmeds',
          merchant_logo:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          primary_category_id: 16,
          merchant_type: null,
          merchant_rank: '80',
        },
      ],
    },
    offer_type: [
      {
        id: 'cashback',
        data: 'Coupon Cashback',
        image:
          'https://static.twidpay.com/co/mobile_app_images/icons/coupon_cashback.png',
      },
      {
        id: 'exclusive_cashback',
        data: 'Brand Coupon',
        image:
          'https://static.twidpay.com/co/mobile_app_images/icons/cashback_blue.png',
      },
    ],
    offer_value: [
      {
        id: '0',
        data: 'All Offers',
      },
      {
        id: '25',
        data: '₹25 or more',
      },
      {
        id: '50',
        data: '₹50 or more',
      },
      {
        id: '100',
        data: '₹100 or more',
      },
    ],
    reward_offer: [],
    platform: [
      {
        id: 'all',
        data: 'All Offers',
      },
      {
        id: 'online',
        data: 'Online brands',
      },
      {
        id: 'offline',
        data: 'Offline stores',
      },
    ],
  },
};

export const MOCK_MERCHANT_LISTING = {
  title: 'Save up to 30%',
  subtitle: 'Explore brands to Pay with Rewards',
  categories: [
    {
      type: 'ONLINE',
      brands: [
        {
          name: 'Jiomart',
          discount: '~15% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/jiomartsquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'ConfirmTkt',
          discount: '~9% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/confirmtktsquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Swiggy',
          discount: '~9% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/swiggysquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Redbus',
          discount: '~11% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/twid.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Bookmyshow',
          discount: '~15% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/bookmyshowsquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Netmeds',
          discount: '~9% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/netmedssquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Ixigo Trains',
          discount: '~9% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/twid.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Eatsure',
          discount: '~11% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/eatsuresquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Vi Prepaid',
          discount: '~11% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/twid.png',
          redicrection_url: 'https://www.twidpay.com',
        },
        {
          name: 'Abhibus',
          discount: '~11% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/square/abhibussquare.png',
          redicrection_url: 'https://www.twidpay.com',
        },
      ],
    },
    {
      type: 'OFFLINE',
      brands: [
        {
          name: 'Reliance',
          discount: '~15% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/rectangle/reliancesmartsrect.png',
        },
        {
          name: 'McDonalds',
          discount: '~12% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/rectangle/mcdonaldsrect.png',
        },
        {
          name: 'Bikanervala',
          discount: '~9% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/rectangle/bikanerwaalarect.png',
        },
        {
          name: 'Wow Momos',
          discount: '~9% OFF',
          logo_url:
            'https://cdn.twidpay.com/co/mobile_app_images/brand_logos/rectangle/wowmomorect.png',
        },
      ],
    },
  ],
  tnc: [
    {
      text: 'Visit the merchant website / app',
    },
    {
      text: 'Add orders to your cart and go to checkout page',
    },
    {
      text: 'Select Pay with rewards on the Payment Page',
    },
    {
      text: 'Use Reward points to make the payment',
    },
    {
      text: 'Enjoy big savings',
    },
  ],
  banner: [
    'https://cdn.twidpay.com/co/mobile_app_images/frontend/sq_earn_banner.png',
    'https://cdn.twidpay.com/co/mobile_app_images/frontend/sq_earn_banner.png',
    'https://cdn.twidpay.com/co/mobile_app_images/frontend/sq_earn_banner.png',
    'https://cdn.twidpay.com/co/mobile_app_images/frontend/sq_earn_banner.png',
  ],
};

export const MOCK_PAY_DAY_OFFERS = {
  payday_banner: {
    imageUrl: paydayAssets?.heroImage,
    eventName: '',
  },
  weekend_banner: {
    imageUrl: paydayAssets?.weekendHeroBanner,
    eventName: '',
  },
  gateway_banner: {
    imageUrl: paydayAssets?.gateWayHeroBanner,
    eventName: '',
  },
  season_of_savings_banner: {
    imageUrl: paydayAssets?.seasonOfSavingsHeroBanner,
    eventName: '',
  },
  republic_day_banner: {
    imageUrl: paydayAssets?.republicDayHeroBanner,
    eventName: '',
  },
  close: {
    imageUrl: paydayAssets?.close,
  },
  categories: [
    {
      imageUrl: paydayAssets?.categories?.food,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Favorite Apps, Your Daily Savings',
      position: 1,
      name: 'Food & Groceries',
    },
    {
      imageUrl: paydayAssets?.categories?.travel,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Favorite Apps, Your Daily Savings',
      position: 2,
      name: 'Travel',
    },
    {
      imageUrl: paydayAssets?.categories?.shopping,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Favorite Apps, Your Daily Savings',
      position: 3,
      name: 'Shopping',
    },
    {
      imageUrl: paydayAssets?.categories?.entertainment,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Favorite Apps, Your Daily Savings',
      position: 4,
      name: 'Entertainment',
    },
    {
      imageUrl: paydayAssets?.categories?.electronics,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Favorite Apps, Your Daily Savings',
      position: 5,
      name: 'Electronics',
    },
  ],
  // redirection link
  rewards: [
    {
      imageUrl: paydayAssets?.rewards?.reliance,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 1,
      name: 'Reliance Fresh',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.cobb,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 2,
      name: 'Cobb',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.barista,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 3,
      name: 'Barista',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.wow,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 4,
      name: 'Wow Momos',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.mcd,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 5,
      name: 'Mc Donalds',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.pizzahut,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 6,
      name: 'Pizza Hut',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.bikernerwala,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 7,
      name: 'Bikernervala',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.archies,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 8,
      name: 'Archies',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.rewards?.manCompany,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 9,
      name: 'Tha Man Company',
      inApp: true,
    },
  ],
  // redirection link
  brandsInSpotlight: [
    {
      imageUrl: paydayAssets?.brands?.Relience,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 1,
      name: 'Reliance Smart + Fresh',
      inApp: true,
    },
    {
      imageUrl: paydayAssets?.brands?.Swiggy,
      redirectUrl: 'https://www.swiggy.com/k=30sep',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 2,
      name: 'Swiggy & Instamart',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.brands?.Jiomart,
      redirectUrl: 'https://jiomart.onelink.me/Qg0u/twidpay',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 3,
      name: 'Jiomart',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.brands?.Nobero,
      redirectUrl: 'https://nobero.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 4,
      name: 'Nobero',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.brands?.Redbus,
      redirectUrl: 'https://www.redbus.in/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 5,
      name: 'Redbus',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.brands?.MyJio,
      redirectUrl: 'https://www.jio.com/mobile',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 6,
      name: 'My Jio',
      inApp: false,
    },
  ],
  //   // redirection link
  otherBrands: [
    {
      logoUrl: paydayAssets?.otherBrands?.confirmTkt,
      redirectUrl: '/offers/mcdonalds',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'ConfirmTkt',
    },
    {
      logoUrl: paydayAssets?.otherBrands?.mmt,
      redirectUrl: '/offers/dominos',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 2,
      name: 'Redbus',
    },
    {
      logoUrl: paydayAssets?.otherBrands?.neeman,
      redirectUrl: '/offers/barista',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 3,
      name: 'Redbus',
    },
    {
      logoUrl: paydayAssets?.otherBrands?.zeraki,
      redirectUrl: '/offers/mcdonalds',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 4,
      name: 'Redbus',
    },
    {
      logoUrl: paydayAssets?.otherBrands?.netmed,
      redirectUrl: '/offers/dominos',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 5,
      name: 'Redbus',
    },
    {
      logoUrl: paydayAssets?.otherBrands?.justherbs,
      redirectUrl: '/offers/dominos',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 6,
      name: 'Redbus',
    },
    {
      logoUrl: paydayAssets?.otherBrands?.es,
      redirectUrl: '/offers/dominos',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 7,
      name: 'Redbus',
    },
  ],
  verifiedBy: [
    {
      logoUrl: paydayAssets?.secure?.verified,
    },
    {
      logoUrl: paydayAssets?.secure?.secure,
    },
    {
      logoUrl: paydayAssets?.secure?.reserve,
    },
  ],
  // redirection link
  app: [
    {
      logoUrl: paydayAssets?.app?.earn,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.app?.reward,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.app?.ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
  gateway_categories: [
    {
      imageUrl: paydayAssets?.gateway_categories?.flight,
      eventName: 'AppWebpageBannerClicked',
      type: 'Travel More, Spend Less – Save up to ₹1,000',
      position: 1,
      name: 'flight',
    },
    {
      imageUrl: paydayAssets?.gateway_categories?.train,
      eventName: 'AppWebpageBannerClicked',
      type: 'Travel More, Spend Less – Save up to ₹1,000',
      position: 2,
      name: 'train',
    },
    {
      imageUrl: paydayAssets?.gateway_categories?.bus,
      eventName: 'AppWebpageBannerClicked',
      type: 'Travel More, Spend Less – Save up to ₹1,000',
      position: 3,
      name: 'bus',
    },
  ],
  weekend_categories: [
    {
      imageUrl: paydayAssets?.categories?.food2,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Weekend, Your Rewards – Don’t Miss Out!',
      position: 1,
      name: 'Food & Groceries',
    },
    {
      imageUrl: paydayAssets?.categories?.travel,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Weekend, Your Rewards – Don’t Miss Out!',
      position: 2,
      name: 'Travel',
    },
    {
      imageUrl: paydayAssets?.categories?.shopping,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Weekend, Your Rewards – Don’t Miss Out!',
      position: 3,
      name: 'Shopping',
    },
    {
      imageUrl: paydayAssets?.categories?.bill,
      eventName: 'AppWebpageBannerClicked',
      type: 'Your Weekend, Your Rewards – Don’t Miss Out!',
      position: 4,
      name: 'Bill Payment',
    },
  ],
  season_of_savings_categories: [
    {
      imageUrl: paydayAssets?.seasonOfSavingsCategories?.ss_food,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 1,
      name: 'Food & Groceries',
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsCategories?.ss_travel,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 2,
      name: 'Travel',
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsCategories?.ss_shopping,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 3,
      name: 'Shopping',
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsCategories?.ss_electronics,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 4,
      name: 'Bill Payment',
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsCategories?.ss_entertainment,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 4,
      name: 'Bill Payment',
    },
  ],
  seasonOfSavingsBrandsInSpotlight: [
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_Redbus,
      redirectUrl: 'https://www.redbus.in/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 6,
      name: 'Redbus',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_Nobero,
      redirectUrl: 'https://nobero.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 1,
      name: 'Nobero',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_Neemans,
      redirectUrl: 'https://neemans.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 2,
      name: 'Neemans',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_Boat,
      redirectUrl: 'http://boat-lifestyle.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 3,
      name: 'Boat',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_EasemyTrip,
      redirectUrl: 'https://www.easemytrip.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 7,
      name: 'EaseMyTrip',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_TheManCompany,
      redirectUrl: 'https://www.themancompany.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 1,
      name: 'The Man Company',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_Eatsure,
      redirectUrl: 'https://www.eatsure.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 4,
      name: 'EatSure',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.seasonOfSavingsSpotlightBrands?.ss_IxigoHotels,
      redirectUrl: 'https://www.ixigo.com/hotels',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 5,
      name: 'Ixigo Hotels',
      inApp: false,
    },
  ],
  seasonOfSavingsOtherBrands: [
    {
      logoUrl: paydayAssets?.seasonOfSavingsOtherBrands?.ssob_ConfirmTkt,
      redirectUrl: '/offers/confirmtkt',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'ConfirmTkt',
    },
    {
      logoUrl: paydayAssets?.seasonOfSavingsOtherBrands?.ssob_BookMyShow,
      redirectUrl: '/offers/bookmyshow',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'BookMyShow',
    },
    {
      logoUrl: paydayAssets?.seasonOfSavingsOtherBrands?.ssob_Neemans,
      redirectUrl: '/offers/neemans',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Neemans',
    },
    {
      logoUrl: paydayAssets?.seasonOfSavingsOtherBrands?.ssob_Zeeraki,
      redirectUrl: '/offers/zeeraki',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Zeeraki Jewels',
    },
    {
      logoUrl: paydayAssets?.seasonOfSavingsOtherBrands?.ssob_Netmeds,
      redirectUrl: '/offers/netmeds',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Netmeds',
    },
  ],
  seasonOfSavingsAppExclusive: [
    {
      logoUrl: paydayAssets?.seasonOfSavingsAppExclusive?.ssae_TwidStars,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.seasonOfSavingsAppExclusive?.ssae_TwidScanAndPay,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.seasonOfSavingsAppExclusive?.ssae_Ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
  republic_day_deals_categories: [
    {
      imageUrl: paydayAssets?.republicDayDealsCategories?.ss_food,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 1,
      name: 'Food & Groceries',
    },
    {
      imageUrl: paydayAssets?.republicDayDealsCategories?.ss_travel,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 2,
      name: 'Travel',
    },
    {
      imageUrl: paydayAssets?.republicDayDealsCategories?.ss_shopping,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 3,
      name: 'Shopping',
    },
    {
      imageUrl: paydayAssets?.republicDayDealsCategories?.rdd_electronics,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 4,
      name: 'Bill Payment',
    },
    {
      imageUrl: paydayAssets?.republicDayDealsCategories?.ss_entertainment,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 4,
      name: 'Bill Payment',
    },
  ],
  republicDayDealsBrandsInSpotlight: [
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_Swiggy,
      redirectUrl: 'https://www.swiggy.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 1,
      name: 'Swiggy',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_JioMart,
      redirectUrl: 'https://jiomart.onelink.me/Qg0u/twidpay%5C',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 2,
      name: 'Jiomart',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_Instamart,
      redirectUrl: 'https://www.swiggy.com/instamart',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 3,
      name: 'Instamart',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_AbhiBus,
      redirectUrl: 'https://www.abhibus.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 4,
      name: 'AbhiBus',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_Eatsure,
      redirectUrl: 'https://www.eatsure.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 5,
      name: 'EatSure',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_Redbus,
      redirectUrl: 'https://www.redbus.in/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 6,
      name: 'Redbus',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_Nobero,
      redirectUrl: 'https://nobero.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 7,
      name: 'Nobero',
      inApp: false,
    },
    {
      imageUrl: paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_EasemyTrip,
      redirectUrl: 'https://www.easemytrip.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 8,
      name: 'EaseMyTrip',
      inApp: false,
    },
    {
      imageUrl:
        paydayAssets?.republicDayDealsBrandsInSpotlight?.rdd_TheManCompany,
      redirectUrl: 'https://www.themancompany.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 9,
      name: 'The Man Company',
      inApp: false,
    },
  ],
  republicDayDealsOtherBrands: [
    {
      logoUrl: paydayAssets?.republicDayDealsOtherBrands?.rdd_ob_ConfirmTkt,
      redirectUrl: '/offers/confirmtkt',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'ConfirmTkt',
    },
    {
      logoUrl: paydayAssets?.republicDayDealsOtherBrands?.rdd_ob_BookMyShow,
      redirectUrl: '/offers/bookmyshow',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 2,
      name: 'BookMyShow',
    },
    {
      logoUrl: paydayAssets?.republicDayDealsOtherBrands?.rdd_ob_Zeeraki,
      redirectUrl: '/offers/zeeraki',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 3,
      name: 'Zeeraki Jewels',
    },
    {
      logoUrl: paydayAssets?.republicDayDealsOtherBrands?.rdd_ob_Netmeds,
      redirectUrl: '/offers/netmeds',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 4,
      name: 'Netmeds',
    },
    {
      logoUrl: paydayAssets?.republicDayDealsOtherBrands?.rdd_ob_JustHerbs,
      redirectUrl: '/offers/justherbs',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 5,
      name: 'JustHerbs',
    },
  ],
  republicDayDealsAppExclusive: [
    {
      logoUrl: paydayAssets?.republicDayDealsAppExclusive?.ssae_TwidStars,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.republicDayDealsAppExclusive?.ssae_TwidScanAndPay,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.republicDayDealsAppExclusive?.ssae_Ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
};
